<template>

  <div class=" box box-cornered">
    <qrcode-stream @init="onInit" @detect="onDetect">

     <div class="cam-inside">
       <div v-if="!scanning && !modelValue" class="scanning">
         <div class="dz-spinner">
           <div class="spinner-grow text-warning spinner-lg me-2" role="status">
           </div>
         </div>
         <h5>En attente...</h5>
         <div class="text-center">
           <span class="">Déplacez votre camera,</span>
           <br>
           <span class="">de sorte à scanner le qrcode de la table.</span>
         </div>
       </div>

       <div v-if="scanning" class="scanning">
         <div class="dz-spinner">
           <div class="spinner-grow text-info spinner-lg me-2" role="status">
           </div>
         </div>
         <span class="sr-only">Scannage en cours...</span>
       </div>

       <div v-if="modelValue && !scanning" class="scanning">
         <div class="modal-body text-center small p-4">
           <i class="fa fa-4x fa-check-circle text-success m-b15"></i>
           <h5>Succès</h5>
           <p class="m-b0">Votre table a bien été enregistrez. Merci</p>
         </div>
       </div>

       <div v-if="error && !scanning && !modelValue" class="scanning">
         <div class="modal-body text-center small p-4">
           <i class="fa fa-4x fa-times-circle text-danger m-b15"></i>
           <h5>Oups</h5>
           <p class="m-b0">Une erreur s'est produite. Veuillez réessayer. Merci!</p>
         </div>
       </div>
     </div>
    </qrcode-stream>
  </div>

</template>

<script setup>
import { QrcodeStream } from 'vue3-qrcode-reader'
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";


const loading = ref(false)
const scanning = ref(false)
const error = ref('')

const store = useStore()
// eslint-disable-next-line no-undef
defineProps({
  modelValue:{}
})

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue'])

onMounted(() => {
})



async function onInit(promise) {
  loading.value = true

  try {
    const {capabilities} = await promise
  } catch (err) {
    if (err.name === 'NotAllowedError') {
      error.value = "user denied camera access permisson"
    } else if (err.name === 'NotFoundError') {
      error.value = "no suitable camera device installed"
    } else if (err.name === 'NotSupportedError') {
      error.value = "page is not served over HTTPS (or localhost)"
    } else if (err.name === 'NotReadableError') {
      error.value = "maybe camera is already in use"
    } else if (err.name === 'OverconstrainedError') {
      error.value = "did you requested the front camera although there is none?"
    } else if (err.name === 'StreamApiNotSupportedError') {
      error.value = "browser seems to be lacking features"
    }
  } finally {
    loading.value = false
  }
}

async function onDetect (promise) {
  scanning.value = true
  try {
    const {
      content,      // decoded String
      location      // QR code coordinates
    } = await promise

    const table = JSON.parse(content)
    await store.dispatch('contact/loadTable', table)
    scanning.value = false
    emit('update:modelValue', table)

  } catch (err) {
    scanning.value = false
    error.value = "unable to read table from scanned QR code"
  }
}
</script>
<style scoped>
.cam-inside{
  position: absolute;
  top: 130%;
  width: 100%;
}
.sr-only{
  position: inherit;
}
.cam-border{
  margin-top: 30px;
  padding: 5px;
}
.dz-timeline.timeline-number .timeline-item .line-content-box{
  box-shadow: 0 0 0 0 transparent;
}

.dz-timeline.timeline-number .timeline-item .line-num{
  box-shadow: 0 0 0 0 transparent;
}

.input-radius textarea.form-control{
  border-radius: 10px;
}
.box {
  margin-top: 30px;
  padding: 5px;
  line-height: 1;
  background-position:  0 0, 0 0, 100% 0, 0 100%;
  background-size: 3px 100%, 100% 3px, 3px 100% , 100% 3px;
  background-repeat: no-repeat;
}

.box-cornered {
  background-image:
      linear-gradient(0deg, #2da333, #2da333 25%, transparent 25%, transparent 75%, #2da333 75%),
      linear-gradient(90deg, #2da333, #2da333 25%, transparent 25%, transparent 75%, #2da333 75%),
      linear-gradient(180deg, #2da333, #2da333 25%, transparent 25%, transparent 75%, #2da333 75%),
      linear-gradient(270deg, #2da333, #2da333 25%, transparent 25%, transparent 75%, #2da333 75%)
;
}

</style>